import { fromJS, List, Map } from 'immutable';
// import { ProductRecord, PackageRecord } from './../Record/Products';
const NAME_SPACE = 'OGNM/';
const initialState = Map({
  'loading': true,
  'data': List([]),
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'ON_SELECT':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('account') === action.payload.account), orders => {
          const _orders = orders.toJS();
          _orders.collection.map(item => {
            for (const iterator of _orders.cache) {
              if (iterator === item.o_id) {
                item.groups_no = _orders.groups_no;
              }
            }
            return item;
          });
          return fromJS(_orders);
        });
      });
    case NAME_SPACE + 'EDIT_ACCOUNT_OBJ':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('account') === action.payload.account), orders => {
          return orders.merge(action.payload.obj);
        });
      });
    case NAME_SPACE + 'EDIT_ORDERS':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('account') === action.payload.account), orders => {
          return orders.update('collection', collection => {
            return collection.update(collection.findIndex(x => x.get('o_id') === action.payload.oId), orders => {
              return orders.merge(action.payload.orders);
            });
          });
        });
      });
    case NAME_SPACE + 'RECEIVE_ORDERS_COLLECTION1':
      return fromJS(action.payload);
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

const OrdersGroupNoManagement = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'UNMOUNT':
      return undefined;
    case NAME_SPACE + 'ON_SELECT':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ACCOUNT_OBJ':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ORDERS':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_ORDERS_COLLECTION1':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};

export default OrdersGroupNoManagement;